import { type DocumentChangeInterface, OperationTypeEnum } from "@finway-group/shared/lib/models"
import * as Sentry from "@sentry/react"
import { type Dispatch } from "redux"
import { PROCESS_ENV } from "~Shared/config/env.utils"
import { fetchAllCompanies } from "~Shared/store/actions/company/companyActions"
import { isClientErrorCode } from "~Shared/utils/errorHandler.utils"
import { EmployeeService } from "../employee.service"

export const subscribeToCompanySettings = (dispatch: Dispatch<any>, data: DocumentChangeInterface) => {
    const {
        fullDocument: { operationType },
    } = data

    try {
        if (operationType === OperationTypeEnum.INSERT || operationType === OperationTypeEnum.UPDATE) {
            dispatch(fetchAllCompanies(false))
        }
    } catch (err) {
        if (isClientErrorCode(err)) {
            return
        }
        Sentry.captureException(`[Company Settings Socket] Error: ${typeof err === "string" ? err : JSON.stringify(err)}`)
    }
}

export const subscribeToCompanySettingsCallbacks = (dispatch: Dispatch<any>, data: DocumentChangeInterface) => {
    // only enable these updates if logged in as the finway admin
    if (EmployeeService.getLoggedInEmployeeProfile().email !== PROCESS_ENV.FINWAY_ADMIN_EMAIL) {
        return
    }

    subscribeToCompanySettings(dispatch, data)
}
